import { Link } from "react-router-dom";
import { Home as HomeIcon, ArrowRight } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-industrial-soft">
      <div className="container-nago text-center py-24">
        <div className="text-[#E30613] font-mono text-sm tracking-widest">404</div>
        <h1 className="mt-4 font-display font-extrabold text-4xl sm:text-5xl text-slate-900">
          That page isn&apos;t here.
        </h1>
        <p className="mt-4 text-slate-600 max-w-lg mx-auto">
          It may have moved. Head back to the homepage or browse our products. Need help finding
          something? Get in touch with our team.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to="/" className="btn-primary" data-testid="notfound-home-btn">
            <HomeIcon className="w-4 h-4" /> Go to Home
          </Link>
          <Link to="/products" className="btn-outline">
            Browse Products <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </div>
  );
}
